import styled from "styled-components";
import { mediaMaxWidth } from "../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  position: fixed;
  height: 60px;
  top: 0;
  left: 0;
  width: 100vw;
  background: #ec5050;
  z-index: 10;
  color: #fff;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    animation-name: fadeInDown;
  }

  @keyframes fadeOutUp {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }
  }

  &.fadeOutUp {
    animation-name: fadeOutUp;
  }

  &.animated {
    animation-duration: 0.5s;
    animation-fill-mode: both;
  }

  &.delay {
    animation-delay: 1s;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  width: calc(100vw - 40px);
  height: 100%;
  margin: 0 auto;
`;

export const Text = styled.div`
  display: table;
`;

export const Line = styled.div`
  display: flex;
  flex: 1;
  font-size: 0.85em;
  font-weight: 400;
  word-spacing: 1px;
  letter-spacing: 0.5px;

  strong {
    margin: 0 5px;

    &:nth-child(2) {
      margin: 0 0 0 5px;
    }
  }

  ${mediaMaxWidth.tablet} {
    font-size: 0.75em;
    word-spacing: unset;
    letter-spacing: unset;
  }
`;

export const Link = styled.a`
  margin: 0 0 0 5px;
  font-weight: 700;
  cursor: pointer;
  color: #fff !important;
  transition: 0.1s ease-in-out;
  text-decoration: underline !important;

  &:nth-child(2) {
    margin: 0 5px;
  }

  &:hover {
    color: #333 !important;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  height: 30px;
  align-items: center;
  justify-content: flex-end;
  font-size: 1.4em;
  cursor: pointer;
  transition: 0.1s ease-in-out;

  &:hover {
    color: #333;
  }

  ${mediaMaxWidth.tablet} {
    font-size: 1.2em;
  }
`;
